import React from 'react';
import ExpandedComponent from "../../microComponents/tablePages/ExpandedComponent";

const ExpandedSeriesHistory = ({item}) => {
    return (
        <ExpandedComponent items={[
            {title: 'نوع', value: item.seriType},
            {title: 'واحد', value: item.branch},
            {title: 'خط تولید', value: item.productLine},
            {title: 'کالا', value: item.product ,class: 'sm:hidden'},
            {title: ' چاپ شده', value: item.printedCounter, class: 'sm:hidden'},

            {
                title: 'تحویل شده',
                value:
                    <div>{item.totalRegistredCounter > 0 && (`${item.registredCounter} (${item.totalRegistredCounter}) `)}</div>,

                class: 'md:hidden'
            },
            {title: 'ابطال', value: item.destroyedCounter, class: '2md:hidden'},
            {
                title: 'در حال بررسی',
                value:
                    <div>{item.totalQuarantineCounter > 0 && (`${item.quarantineCounter} (${item.totalQuarantineCounter}) `)}</div>,
                class: '2md:hidden'
            },
            {
                title: 'امحا',
                value:
                    <div>{item.totalDestroyedCounter > 0 && (`${item.destroyedCounter} (${item.totalDestroyedCounter}) `)}</div>,
                class: 'lg:hidden'
            },
            {title: 'بازسازی شده', value: item.totalReconstructCounter, class: 'lg:hidden'},
            {title: 'تعداد کالا', value: item.numberPerPallet, class: 'lg:hidden'},
            // {title: 'سرپرست تولید', value: item.createBy, class: 'lg:hidden'},
            // {title: 'تاریخ ثبت', value: item.startTime, class: 'lg:hidden'},
            // {title: 'زمان پایان', value: item.endTime, class: 'lg:hidden'},

        ]}/>
    );
};

export default ExpandedSeriesHistory;